import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ref, onDisconnect, set, push, get } from 'firebase/database';

@Injectable({
    providedIn: 'root'
})
export class SessionService {
    constructor(private auth: AuthService) { }

    /**
     * Join Room: Persist roomId locally for reconnection.
     */
    async joinRoom(roomId: string) {
        localStorage.setItem('lastRoomId', roomId);
        // Note: Actual DB joining (assignments) is done in CallsService
    }

    getLastRoomId(): string | null {
        return localStorage.getItem('lastRoomId');
    }

    clearRoom() {
        localStorage.removeItem('lastRoomId');
    }

    async verifyRoomPersistence(roomId: string): Promise<boolean> {
        const user = this.auth.currentUser;
        if (!user) return false;

        try {
            const snapshot = await get(ref(this.auth.realtimeDb, `users/${user.uid}/rooms/${roomId}`));
            return snapshot.exists();
        } catch (err) {
            console.error('Verify room failed', err);
            return false;
        }
    }

    async getPairedRooms(): Promise<string[]> {
        const user = this.auth.currentUser;
        if (!user) return [];

        try {
            const snapshot = await get(ref(this.auth.realtimeDb, `users/${user.uid}/rooms`));
            if (snapshot.exists()) {
                return Object.keys(snapshot.val());
            }
            return [];
        } catch (err) {
            console.error('Get paired rooms failed', err);
            return [];
        }
    }

    /**
     * Debug Log
     * Writes to: room_metadata/{roomId}/logs/{camUid}
     * (Optional: Might want to disable in prod or use different path)
     */
    log(roomId: string, context: string, message: string) {
        const user = this.auth.currentUser;
        if (!user) return;

        // Use a separate logs node to avoid polluting metadata
        const logPath = `room_logs/${roomId}/${user.uid}`;
        const logEntry = `[CAM] ${new Date().toISOString()} [${context}] ${message}`;
        push(ref(this.auth.realtimeDb, logPath), logEntry).catch(err => console.error('Log failed', err));
        console.log(logEntry);
    }
}
